import { gql, useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import * as React from 'react';

import { logError } from '@/imports/logging/ClientLogger';

import { usePrepareCompanyCsv_PrepCompanyCsvUpload } from './graphql-types/usePrepareCompanyCsv_PrepCompanyCsvUpload';

const PREP_COMPANY_CSV_UPLOAD_MUTATION = gql`
  mutation usePrepareCompanyCsv_PrepCompanyCsvUpload {
    prepOrganizationCsvUpload {
      presignedS3Url
      csvUploadId
      metadataHeaders {
        name
        value
      }
    }
  }
`;

export const usePrepareCompanyCsv = (): {
  prepareCompanyCsv: () => Promise<void>;
  prepareCompanyCsvData:
    | usePrepareCompanyCsv_PrepCompanyCsvUpload
    | null
    | undefined;
  prepareCompanyCsvLoading: boolean;
  clearCsvResult: () => void;
} => {
  const toast = useToast();

  const [
    prepareCompanyCsv,
    { loading: prepareMutationLoading, data: companyCsvPrepMutationData },
  ] = useMutation<usePrepareCompanyCsv_PrepCompanyCsvUpload>(
    PREP_COMPANY_CSV_UPLOAD_MUTATION
  );

  const [csvPrepped, setCsvPrepped] = React.useState(false);

  const prepareCompanyCsvData = csvPrepped
    ? companyCsvPrepMutationData
    : undefined;

  React.useEffect(() => {
    if (!!companyCsvPrepMutationData) {
      setCsvPrepped(true);
    }
  }, [companyCsvPrepMutationData]);

  const handlePrepCompanyCsvUpload = async (): Promise<void> => {
    try {
      await prepareCompanyCsv();
    } catch (err) {
      toast({
        title: 'Failed to prepare the csv upload. Please try again.',
        status: 'error',
      });
      logError(err);
    }
  };

  return {
    prepareCompanyCsv: handlePrepCompanyCsvUpload,
    prepareCompanyCsvData,
    prepareCompanyCsvLoading: prepareMutationLoading,
    clearCsvResult: () => setCsvPrepped(false),
  };
};
